export default __webpack_public_path__ + "static/media/tick.2d4a19a4.svg";